import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class LayoutWrap extends BaseOption {
  static userInterfaceComponent = {
    label: "Wrap",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Wrap",
          value: "wrap",
        },
        {
          label: "No Wrap",
          value: "nowrap",
        },
        {
          label: "Wrap Reverse",
          value: "wrap-reverse",
        },
      ],
    },
  };

  static defaultValue = "nowrap";
}
